import i18n from '@i18n/i18n';
import { getUserTimezone } from '@utils/dateTime';

const AI_BASE_URL = '/api/ai/v1/';

const aiFetch = async (url, options = {}) => {
  const { params, ...fetchOptions } = options;

  let fullUrl = `${AI_BASE_URL}${url}`;

  if (params) {
    const urlObj = new URL(fullUrl, window.location.origin);
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        urlObj.searchParams.set(key, value);
      }
    });
    fullUrl = urlObj.toString();
  }

  const response = await fetch(fullUrl, {
    credentials: 'include',
    headers: {
      'Accept-Language': i18n.language || 'zh',
      'X-Timezone': getUserTimezone(),
    },
    ...fetchOptions,
  });

  if (response.status === 401) {
    window.location.href = '/operator/login?reason=session_expired';
    throw new Error('Unauthorized');
  }

  return response;
};

const aiAuditLogService = {
  getRecords: async (params) => {
    const { page, page_size, sorting_field, sorting_direction, ...filters } = params;
    const resp = await aiFetch('audit_logs', {
      params: { page, page_size, sorting_field, sorting_direction, ...filters },
    });
    return resp.json();
  },
};

export default aiAuditLogService;
